import {
  BannerAspect,
  BannerGallerySource,
} from "@/@types/gamification";

import { BANNER_GALLERY_COPY, CUSTOMER_FACING_COPY } from "./messages";

export const BANNER_GALLERY_SEARCH_DEBOUNCE_MS = 400;

export const GallerySourceFilter = {
  ALL: "ALL",
  DEFAULT: BannerGallerySource.DEFAULT,
  CAMPAIGN: BannerGallerySource.CAMPAIGN,
} as const;

export type GallerySourceFilter =
  (typeof GallerySourceFilter)[keyof typeof GallerySourceFilter];

export const GALLERY_SOURCE_FILTER_OPTIONS: ReadonlyArray<{
  value: GallerySourceFilter;
  label: string;
}> = [
  { value: GallerySourceFilter.ALL, label: BANNER_GALLERY_COPY.sourceAll },
  { value: GallerySourceFilter.DEFAULT, label: BANNER_GALLERY_COPY.sourceDefault },
  { value: GallerySourceFilter.CAMPAIGN, label: BANNER_GALLERY_COPY.sourceCampaign },
];

export const GALLERY_ALL_GAMES = "ALL" as const;

export const BANNER_ASPECT_RATIO_LABELS: Record<BannerAspect, string> = {
  [BannerAspect.WIDE]: CUSTOMER_FACING_COPY.alternativeRatio,
  [BannerAspect.PORTRAIT]: CUSTOMER_FACING_COPY.coverRatio,
};

export const BANNER_ASPECT_CLASSES: Record<BannerAspect, string> = {
  [BannerAspect.WIDE]: "aspect-[16/9]",
  [BannerAspect.PORTRAIT]: "aspect-[3/4]",
};

export const BANNER_SOURCE_BADGES: Record<BannerGallerySource, string> = {
  [BannerGallerySource.DEFAULT]: BANNER_GALLERY_COPY.badgeDefault,
  [BannerGallerySource.CAMPAIGN]: BANNER_GALLERY_COPY.badgeCampaign,
};
